<template>
  <div class="position--relative">
    <horizontal-type-d class="spacing--lg">
    </horizontal-type-d>
    <slot></slot>
    <!-- <hospital-footer-tab></hospital-footer-tab> -->
    <footer-type-a></footer-type-a>
  </div>
</template>

<script>
export default {
  components: {
    HorizontalTypeD: () => import('@/component/layout/header/horizontal/TypeD'),
    // HospitalFooterTab: () => import('@/component/layout/footer/custom/Hospital-ys'),
    FooterTypeA: () => import('@/component/layout/footer/TypeA')
  }
}
</script>
